























































































































































































import { Vue, Component } from 'vue-property-decorator';
import axios from '@/services/axios';
import wx from 'weixin-sdk-js';

interface course {
  id: number;
  course: string;
  courseDetail?: string;
}
declare const window: any;

@Component
export default class App extends Vue {
  private visibleLayerIntroduce: boolean = false;
  private courseList: Array<course> = [
    {
      id: 1,
      course: 'UE4入门',
      courseDetail: '通过本节课可以了解常见的主流游戏引擎有哪些，并对UE4引擎的入门和基本使用有所收获。'
    },
    {
      id: 2,
      course: '游戏模式',
      courseDetail: '通过本课程可掌握整套游戏流程的构建，session功能的使用。'
    },
    {
      id: 3,
      course: 'UMG界面',
      courseDetail:
        '通过本课程可学习UE4引擎中UI的制作方法和基本概念，简单了解UI的底层实现方式，以及如何在游戏中使用UI并保持良好的游戏性能。'
    },
    {
      id: 4,
      course: '骨骼动画',
      courseDetail: '通过本课程了解到游戏动画的基本原理，以及在UE4中如何使用骨骼动画来做角色动作表现。'
    },
    {
      id: 5,
      course: '基本物理',
      courseDetail: '通过本课程了解到基本的物理学知识及UE4引擎的物理模块，可以初步使用UE4引擎完成物理相关的功能开发。'
    },
    {
      id: 6,
      course: 'UE4网络同步',
      courseDetail:
        '本课程主要介绍网络的基础概念，一些数据同步的方法和相应的优缺点，详细介绍UE4网络同步使用方法，并深入理解UE4网络同步实现机制。'
    },
    {
      id: 7,
      course: 'AI技术介绍',
      courseDetail: '通过学习本课程可以对不同类型游戏的AI技术有个整体的了解，并对UE4的行为树的使用有个简单的了解。'
    },
    {
      id: 8,
      course: 'UE4C++代码规范',
      courseDetail:
        '通过对UE4 C++代码规范的学习与了解，主要帮助树立规范代码的意识，并在UE4游戏开发实践中逐步形成良好的C++代码习惯与风格，提升自己的编码质量。'
    },
    {
      id: 9,
      course: '结业上机考核'
    }
  ];
  private courseDetail: course = this.courseList[0];

  showLayerIntroduce(obj: course): void {
    this.courseDetail = obj;
    this.visibleLayerIntroduce = true;
  }

  public ERCodeLocation: string = `url(//game.weixin.qq.com/cgi-bin/comm/qrcode?s=10&m=1&d=${encodeURIComponent(
    window.location.href
  )})`;

  mounted(): void {
    axios.get(`/mobile/weixin/config?url=${encodeURIComponent(window.location.href)}`).then(res => {
      wx.config(res.data.data);
      wx.ready(() => {
        const shareData = {
          title: '2020腾讯游戏客户端开发公开课',
          desc: '全球招生启动，pick热爱游戏的你！',
          imgUrl: 'https://tig.qpic.cn/m/share/activity/clientdev2020-share.jpg',
          link: `${window.location.origin}${window.location.pathname}`,
          success: () => {
            /* global MtaH5 */
            window.MtaH5.clickStat('clientdev_2020_share');
          }
        };
        wx.onMenuShareTimeline(shareData);
        wx.onMenuShareAppMessage(shareData);
      });
    });
  }
}
